import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
window.axios = require('axios')
Vue.config.productionTip = false
const clientId = document.getElementById('cc-1919-app').getAttribute('data-id');
var vm = new Vue({
  render: h => h(App, {props: {clientId: clientId}}),
  mounted() {
      this.$refs = {modal: this.$children[0]};
    }
}).$mount('#cc-1919-app');
global.vm = vm;
